import { useQuery } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import { databaseKeys } from "@/queries/queryKeys";

export const createDatabaseQueryHooks = ({
    apiODIN,
}: {
    apiODIN: TApiODIN;
}) => {
    const useCompaniesQuery = (options?: { enabled?: boolean }) =>
        useQuery({
            queryKey: databaseKeys.companies(),
            queryFn: async () => {
                const response = await apiODIN.getCompanies();
                return response.data;
            },
            enabled: options?.enabled,
        });

    return {
        useCompaniesQuery,
    };
};

export type TDatabaseQueryHooks = ReturnType<typeof createDatabaseQueryHooks>;
